/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Nemělo by se pravidlo aktivovat jen pro Node.js?
/* eslint-disable node/no-callback-literal */

import EventEmitter from 'eventemitter3';

/**
 * Naslouchač změnám v připojení k síti pro standardní webové API.
 * @implements {NetworkListener}
 */
class WebNetworkListener {
  /**
   * Vytvoří instanci.
   * @param {EventTarget} eventTarget Zdroj událostí `online` a `offline`.
   * @param {NavigatorOnLine} navigator Zdroj hodonty `onLine`.
   */
  constructor(eventTarget, navigator) {
    /**
     * Správce událostí.
     * @private
     * @type {EventEmitter}
     */
    this.emitter = new EventEmitter();
    this.eventTarget = eventTarget;
    this.listenerMap = new Map();
    this.navigator = navigator;
    // Navázání naslouchání na instanci.
    this.onOffline = this.onOffline.bind(this);
    this.onOnline = this.onOnline.bind(this);
  }

  /**
   * Zjistí, jestli je zařízení aktuálně připojeno k síti.
   * @returns {boolean} Příznak, jestli je zařízení připojeno k síti.
   */
  isOnline() {
    return this.navigator.onLine;
  }

  /** @inheritdoc */
  off(type, callback) {
    const { eventTarget, listenerMap } = this;
    // Zatím je podporována pouze událost onlineChanged, ostatní jsou ignorovány.
    if (type !== 'onlineChanged') {
      return;
    }
    // Odebírání neexistujících callbacků je ignorováno.
    if (!listenerMap.has(callback)) {
      return;
    }
    // Vyhledá se odpovídající listener a odregistruje se.
    const { onOffline, onOnline } = listenerMap.get(callback);
    listenerMap.delete(callback);
    eventTarget.removeEventListener('offline', onOffline);
    eventTarget.removeEventListener('online', onOnline);
  }

  /** @inheritdoc */
  on(type, callback) {
    const { eventTarget, listenerMap } = this;
    // Zatím je podporována pouze událost onlineChanged, ostatní jsou ignorovány.
    if (type !== 'onlineChanged') {
      return;
    }
    // Opakované přidání stejného callbacku je ignorováno.
    if (listenerMap.has(callback)) {
      return;
    }
    // Vytvoří se nový listener a zaregistruje se.
    const onOffline = () => callback(false);
    const onOnline = () => callback(true);
    listenerMap.set(callback, { onOffline, onOnline });
    eventTarget.addEventListener('offline', onOffline);
    eventTarget.addEventListener('online', onOnline);
  }

  /**
   * Reakce na přechod do offline stavu.
   * @private
   * @returns {undefined} Nic.
   */
  onOffline() {
    this.emitter.emit('onlineChanged', false);
  }

  /**
   * Reakce na přechod do online stavu.
   * @private
   * @returns {undefined} Nic.
   */
  onOnline() {
    this.emitter.emit('onlineChanged', true);
  }
}

export default WebNetworkListener;
